import React from 'react';
import { useDealershipSettings } from '../../contexts/settingsContext';
import './SettingsUpdateNote.css';

/**
 * After dealership settings are saved, the new values apply only once the
 * rebuilt inventory has arrived (QA S-8). Meanwhile a small note says the
 * figures are updating; if the reload fails, it says so and offers a retry.
 */
export default function SettingsUpdateNote() {
    const { updating, updateError, retryUpdate } = useDealershipSettings();
    if (!updating && !updateError) return null;
    return (
        <div className="v2-settings-note" role="status" data-testid="settings-update-note">
            {updating ? (
                <>
                    <span className="v2-settings-note-spin" aria-hidden="true" />
                    Updating figures for the new dealership settings…
                </>
            ) : (
                <>
                    The figures could not be updated, so the previous settings stay in use.
                    <button type="button" className="v2-settings-note-btn" onClick={() => retryUpdate()}>Try again</button>
                </>
            )}
        </div>
    );
}
